import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { atom, useRecoilValue } from "recoil";
import styled from "styled-components";
import { getSubscriptionOptionList } from "../../../../AdminApi/commFunc";
import { matchingFilterState } from "../../../../pages/Party/MatchingInfo";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import LineBtn from "../../../Button/LineBtn";
import FilterIcon from "../../../DefaultStyles/FilterIcon";
import Flex from "../../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import RangeSlider from "../../../Filters/RangeSlider";
import Search from "../../../Filters/Search";

interface SFilterContainer {
  windowSize?: number;
}

interface MatchingInfoFilterProps {
  setSearchValue: Dispatch<SetStateAction<string | undefined>>;
  filteringValue: {
    isClicked: boolean;
    servsubsid: string;
    min: number;
    max: number;
    today: boolean;
  };
  setFilteringValue: any;
  userDropdownValue: any;
  setUserDropdownValue: any;
  setPage: Dispatch<SetStateAction<number>>;
  disabled: boolean;
}

// 파티 기간 state 값
export const matchingRangeState = atom<any>({
  key: "matchingRangeState",
  default: [0, 0],
});

export default function MatchingInfoFilter({
  setSearchValue,
  filteringValue,
  setFilteringValue,
  userDropdownValue,
  setUserDropdownValue,
  setPage,
  disabled,
}: MatchingInfoFilterProps) {
  const matchingInfoFilter = useRecoilValue(matchingFilterState);

  const [windowSize, setWindowSize] = useState(0);

  const [subsDropdownValue, setSubsDropdownValue] = useState<OptionType>({
    // subscription 값
    value: "",
    label: "Subscription 선택",
  });
  const [startDate, setStartDate] = useState<OptionType>({
    // 매칭 시작일
    value: "",
    label: "매칭 시작일",
  });
  const [refreshBtnClick, setRefreshBtnClick] = useState(false);

  const sliderValue = useRecoilValue(matchingRangeState); // 파티 기간 값

  console.log(sliderValue);

  // subscription 선택 옵션
  const subsOptionList = getSubscriptionOptionList();

  const startDateOptionList = [
    { label: "오늘 시작", value: "today" },
    { label: "직접 선택", value: "today" },
  ];

  useEffect(() => {
    setWindowSize(window.innerWidth);
    window.addEventListener("resize", () => {
      setWindowSize(window.innerWidth);
    });

    return () => {
      window.removeEventListener("resize", () => {
        setWindowSize(window.innerWidth);
      });
    };
  }, []);

  console.log(
    (subsDropdownValue?.value === "" && sliderValue[0] === 0) ||
      !filteringValue?.today,
    subsDropdownValue?.value,
    sliderValue[0],
    filteringValue?.today
  );

  return (
    <FilterContainer windowSize={windowSize}>
      <Flex gapSize={10}>
        <DropDown
          boxWidth={180}
          dropdownValue={userDropdownValue}
          setDropDownValue={setUserDropdownValue}
        />

        <Search
          placeholder="입력"
          setSearchValue={setSearchValue}
          defaultValue={
            matchingInfoFilter?.searchValue !== ""
              ? matchingInfoFilter?.searchValue
              : undefined
          }
          isDisabled={userDropdownValue?.value === ""}
          pageResetEvent={() => setPage(0)}
          inputType={
            userDropdownValue?.value === "phone" ||
            userDropdownValue?.value === "uid"
              ? "number"
              : undefined
          }
        />
      </Flex>

      <Flex gapSize={10}>
        <FilterIcon />

        <Flex gapSize={10}>
          <>
            <DropDown
              initText="Subscription 선택"
              optionList={subsOptionList}
              dropdownValue={subsDropdownValue}
              setDropDownValue={setSubsDropdownValue}
            />

            <RangeSlider refreshBtnClick={refreshBtnClick} />

            <ConfirmBtn
              btnText="적용"
              btnColor="mint"
              btnHeight={38}
              btnClickEvent={() => {
                setPage(0);
                setFilteringValue({
                  ...filteringValue,
                  isClicked: true,
                  servsubsid:
                    subsDropdownValue?.value !== ""
                      ? Number(subsDropdownValue?.value)
                      : "",
                  min: sliderValue[0],
                  max: sliderValue[1],
                });
              }}
              isDisabled={
                subsDropdownValue?.value === "" && sliderValue[0] === 0
              }
            />

            <LineBtn
              btnText="오늘"
              icon="filter_list"
              btnHeight={38}
              sPadding={"10px 12px 10px 10px"}
              disabled={disabled}
              btnClickEvent={() => {
                setFilteringValue({
                  ...filteringValue,
                  today: true,
                });
              }}
            />

            <LineBtn
              btnColor="mint"
              btnText="초기화"
              icon="refresh"
              btnHeight={38}
              disabled={
                !filteringValue?.today &&
                subsDropdownValue?.value === "" &&
                sliderValue[0] === 0
              }
              btnClickEvent={() => {
                setRefreshBtnClick(true);
                setSubsDropdownValue({
                  value: "",
                  label: "Subscription 선택",
                });

                setFilteringValue({
                  isClicked: false,
                  servsubsid: "",
                  min: 0,
                  max: 0,
                  today: false,
                });
              }}
            />
          </>
        </Flex>
      </Flex>
    </FilterContainer>
  );
}

const FilterContainer = styled.div<SFilterContainer>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;

  @media screen and (max-width: 1300px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
